import { render, staticRenderFns } from "./PolizaView.vue?vue&type=template&id=2f3ff860&scoped=true"
import script from "./PolizaView.vue?vue&type=script&lang=js"
export * from "./PolizaView.vue?vue&type=script&lang=js"
import style0 from "./PolizaView.vue?vue&type=style&index=0&id=2f3ff860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3ff860",
  null
  
)

export default component.exports